import { Node_Type, RichContent } from "./../../../../ricos-schema/legacy/wix/rich_content/v1";
import { getParagraphNode } from "../../draft/toDraft/decorationParsers";
import {
  parseAppEmbed,
  parseAudio,
  parseEmbed,
  parseGiphy,
  parseImage,
  parseLinkPreview,
  parseListNode,
  parseMap,
  parseTextNodes,
  parseVideo
} from "./convertNodes";
function* parseCollapsible(node, delimiter) {
  const collapsibleTextNodes = [];
  for (const child of node.nodes ?? []) {
    const [first, second] = child.nodes ?? [];
    if (!first || !second) {
      continue;
    }
    collapsibleTextNodes.push(
      [yield* toPlainTextBase(first), yield* toPlainTextBase(second)].join(delimiter)
    );
  }
  return collapsibleTextNodes.join(delimiter);
}
function* toPlainTextBase(content, delimiter = "\n", addLinksToText = true) {
  const ricosContent = RichContent.fromJSON(content);
  const { nodes = [] } = ricosContent;
  let plainText = "";
  for (let index = 0; index < nodes.length; index++) {
    const node = nodes[index];
    if (node) {
      if (index > 0) {
        plainText += delimiter;
      }
      switch (node.type) {
        case Node_Type.CODE_BLOCK:
        case Node_Type.PARAGRAPH:
        case Node_Type.HEADING:
          plainText += parseTextNodes(node, addLinksToText);
          break;
        case Node_Type.BLOCKQUOTE:
          plainText += parseTextNodes(getParagraphNode(node), addLinksToText);
          break;
        case Node_Type.ORDERED_LIST:
        case Node_Type.BULLETED_LIST:
          plainText += parseListNode(node, delimiter, addLinksToText);
          break;
        case Node_Type.GIF:
          plainText += yield* parseGiphy(node);
          break;
        case Node_Type.MAP:
          plainText += parseMap(node);
          break;
        case Node_Type.APP_EMBED:
          plainText += parseAppEmbed(node, delimiter);
          break;
        case Node_Type.LINK_PREVIEW:
          plainText += parseLinkPreview(node);
          break;
        case Node_Type.EMBED:
          plainText += parseEmbed(node);
          break;
        case Node_Type.IMAGE:
          plainText += yield* parseImage(node, delimiter);
          break;
        case Node_Type.VIDEO:
          plainText += yield* parseVideo(node, delimiter);
          break;
        case Node_Type.AUDIO:
          plainText += yield* parseAudio(node, delimiter);
          break;
        case Node_Type.COLLAPSIBLE_LIST:
          plainText += yield* parseCollapsible(node, delimiter);
          break;
        default:
      }
    }
  }
  return plainText;
}
export {
  toPlainTextBase
};
//# sourceMappingURL=to-plain-text-base.js.map
